import { AddressModel } from 'src/app/core/models/address.model';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { GlobalComponent } from 'src/app/global-component';
import { Component, Input } from '@angular/core';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { Observable, Subscription } from 'rxjs';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { TimelineModel } from 'src/app/core/models/timeline/timeline.model';
import { DomSanitizer } from '@angular/platform-browser';
import { AccountStatus, UserModel } from 'src/app/core/models/members/user/user.model';
import { UserSignaturePadService } from '../modals/user-signature-pad-modal/user-signature-pad.service';
import { SocialNetworksModel } from 'src/app/core/models/members/user/social-networks.model';
import { CreditCardPaymentInfoModel } from 'src/app/core/models/members/user/credit-card-payment-info-model';
import { Roles, RoleValueAdmin, RoleValueCSR, RoleValueProfile, RoleValueSandbox, RoleValueWitness } from 'src/app/core/security/roles';
import { NotificationSettingsModel } from 'src/app/core/models/members/user/notification-settings-model';
import { OperationsService } from 'src/app/core/services/list-services/operations.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { AuthContext } from 'src/app/core/models/auth-context.model';
import {  AuthorizedOperations } from 'src/app/core/models/authorized-operations.model';
import { OperationsModel } from 'src/app/core/models/members/user/operations.model';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { BaseModalWithProfilePhotoComponent } from '../modals/base-modal-with-profile-photo/base-modal-with-profile-photo.component';
import { OwnerEntityType } from 'src/app/core/enums/owner-entity-type-enum';
import { SignatureModalService } from '../modals/signature-request/signature-modal.service';
import { SettingsModel } from 'src/app/core/models/system/settings.model';
import { passwordComplexityOptions } from 'src/app/core/security/password-complexity-options.model';
import { LoginProviderEnum } from 'src/app/core/enums/login-provider-enum';
import { OperationAccess } from 'src/app/core/enums/operation-access-enum';
import { UserPermissionModalService } from 'src/app/core/services/modal-services/user-permission-modal.service';

export enum userProfileDisplayOptions {
  ProfilePage = 0,
  Modal = 1
}

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})

export class UserProfileComponent extends BaseModalWithProfilePhotoComponent {
  statusOptionsList = [
    { value: AccountStatus.Approved, selectedText: $localize`:@@:Approved`, dropdownText: $localize`:@@:Approved` },
    { value: AccountStatus.Disabled, selectedText: $localize`:@@:Disabled`, dropdownText: $localize`:@@:Disabled` },
    { value: AccountStatus.Onboarding, selectedText: $localize`:@@:Onboarding`, dropdownText: $localize`:@@:Onboarding` },
    { value: AccountStatus.Pending, selectedText: $localize`:@@:Pending`, dropdownText: $localize`:@@:Pending` },
    { value: AccountStatus.PasswordReset, selectedText: $localize`:@@:Password Reset`, dropdownText: $localize`:@@:Password Reset` },
  ];

  emailPattern = GlobalComponent.emailPattern;
  datePattern = GlobalComponent.datePattern;

  maritalList = GlobalComponent.maritalList;
  genderList = GlobalComponent.genderList;

  entityTypeId = EntityTypeEnum.User;

  activeTabId: number = 1;

  loginType?: LoginType = this.authMyFileService.currentUserContextValue?.loginType;

  modelStatus: string = "";

  timeLineItem: TimelineModel = new TimelineModel();
  reloadTimeline: boolean = true;

  //Password Reset Boolean variables used for Error Messages and Validation
  userOldPassword: string = '';
  userNewPassword: string = '';
  userConfirmPassword: string = '';
  userOldPasswordInvalid: boolean = false;
  passwordSubmit: boolean = false;

  //new credit card variables for error messages and validation 
  creditCardPaymentInfoModel: CreditCardPaymentInfoModel = new CreditCardPaymentInfoModel();
  nameOnCard: String = "None"
  numberOnCard: String = "None"
  creditCardSubmit: boolean = false;

  username: string = '';

  securityPermissionIsInRoleAdmin: boolean = this.authMyFileService.isInRole(Roles.admin);
  securityPermissionUserCreate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.user.userCreate);
  securityPermissionUserUpdate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.user.userUpdate);
  securityPermissionUserManagement: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.user.userManagement);
  securityPermissionUserCreateNote: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.user.userUpdate);

  //used for TimeLines Enum
  OwnerEntityType = OwnerEntityType;

  //enums for Html
  LoginType = LoginType;

  //variables for the operations List - move this stuff out later into its own thing that extends BaseList component. 
  private unsubscribe: Subscription[] = [];
  treeControl = new NestedTreeControl<OperationsModel>(node => node.children);
  dataSource = new MatTreeNestedDataSource<OperationsModel>();
  rolesList: string[] = [Roles.admin, Roles.globalAdmin, Roles.csr, Roles.profile, Roles.sandbox, Roles.witness]
  oldArrayList: string[] = []
  selectedRolesArray: string[] = []
  selectedAccessTypesArray: any[] = []
  operationAccessList: any[] = [{ name: "None", type: OperationAccess.None }, { name: "Full", type: OperationAccess.Full }, { name: "Inherited", type: OperationAccess.Inherited }, { name: "Custom", type: OperationAccess.Custom }];
  isRolesListOpen: boolean = false;
  isOperationAccessListOpen: boolean = false;
  operationsList!: Observable<OperationsModel>;
  isLoading!: Observable<Boolean>;
  operations?: any;
  contextOperations?: string[];
  outPutOperations: string[] = [];
  newContext: AuthContext = new AuthContext;
  isLoadingVal: boolean = false

  settingsModel: SettingsModel = new SettingsModel();

  oldPasswordNonValid: string | undefined = undefined;
  passwordNonValid: string | undefined = undefined;
  confirmPasswordNonValid: string | undefined = undefined;

  passwordFieldTextTypeOld: boolean = false;
  passwordFieldTextTypeNew: boolean = false;
  passwordFieldTextTypeConfirmation: boolean = false;

  isAdminPasswordResetNonValid: boolean = false;
  passwordFieldTextTypeAdminReset: boolean = false;
  adminPasswordReset: string | undefined = undefined;
  adminResetPasswordNonValid: string | undefined = undefined;

  loginProviderEnum = LoginProviderEnum;

  constructor(
    protected signatureService: UserSignaturePadService,
    protected operationsListService: OperationsService,
    protected userPermissionModalService: UserPermissionModalService,
    protected clientSignatureModalService: SignatureModalService,
    protected override myFileApiService: MyfileApiService,
    protected override authMyFileService: AuthMyfileService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer
  ) {
    var modalRef: any;
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
    if (this.securityPermissionIsInRoleAdmin) {
      this.operationsList = this.operationsListService.resultItems$;
    }
  }

  @Input() public override  model: UserModel = new UserModel();
  @Input() public tenantId?: string = undefined;
  @Input() public display?: userProfileDisplayOptions = undefined;

  ngOnInit(): void {

    //this is here as a load check on new UserModels and on the off chance a legacy model is opened before it can be called bellow. 
    if (this.model.address === undefined) {
      this.model.address = new AddressModel();
    }

    if (this.model.socialNetworks === undefined) {
      this.model.socialNetworks = new SocialNetworksModel();
    }

    this.model.notificationSettings = { ...new NotificationSettingsModel(), ...this.model.notificationSettings }

    if (this.model.id === undefined) {
      this.newModel = true;
    } else {

      //we need to get the userModel fully here for both when it is opened through Page and from Modal which is a BaseUserModel
      this.disableEditing = true;

      var sub: Subscription = this.myFileApiService.getUser(this.model.id, this.tenantId)
        .subscribe((userModel: UserModel | undefined) => {
          if (userModel) {
           
            this.loadProfilePhoto(userModel.id!,  this.entityTypeId, userModel.profilePhotoFileId, userModel.fullName);
            
            if (userModel.coverPhotoFileId !== undefined) {
              this.loadCoverPhoto(userModel.id!, userModel.coverPhotoFileId!, this.entityTypeId);
            }

            if (!userModel.paymentInfo) {
              userModel.paymentInfo = new CreditCardPaymentInfoModel();
              userModel.paymentInfo.billingAddress = new AddressModel();
            } else {
              if (!(userModel.paymentInfo.cardHolderName == undefined || userModel.paymentInfo.cardHolderName == "")) {
                this.nameOnCard = userModel.paymentInfo.cardHolderName;
              }
              if (!(userModel.paymentInfo.creditCardNumber == undefined || userModel.paymentInfo.cardHolderName == "")) {
                this.numberOnCard = `xxxx xxxx xxxx ${userModel.paymentInfo.creditCardNumber.substring(userModel.paymentInfo.creditCardNumber.length - 4)}`
              }
              if (!userModel.paymentInfo.billingAddress) {
                userModel.paymentInfo.billingAddress = new AddressModel();
              }
              this.creditCardPaymentInfoModel.billingAddress = userModel.paymentInfo.billingAddress;
            }

            userModel.socialNetworks = { ...new SocialNetworksModel(), ...userModel.socialNetworks }
            userModel.notificationSettings = { ...new NotificationSettingsModel(), ...userModel.notificationSettings }

            if (userModel.userName) {
              this.username = userModel.userName;
            }

            if (userModel.status || userModel.status == 0) {
              switch (userModel.status) {
                case 0:
                  this.modelStatus = GlobalComponent.statusList[4];
                  break;
                case 1:
                  this.modelStatus = GlobalComponent.statusList[3];
                  break;
                case 2:
                  this.modelStatus = GlobalComponent.statusList[1];
                  break;
                case 3:
                  this.modelStatus = GlobalComponent.statusList[2];
                  break;
                case 4:
                  this.modelStatus = GlobalComponent.statusList[5];
                  break;
              }
            }
            //we only set the model to the userModel at the end because otherwise it could cause issue on the HTML, not finding the correct elements. 
            this.model = userModel;

             //admin security section here is generated by this code. 
            if (this.securityPermissionIsInRoleAdmin) {
              this.operationsListService.pageIndex = this.operationsListService.pageIndex;

              var sub: Subscription = this.operationsList.subscribe((results: any) => {
                if (results && results[0] && results[0].name) {
                  this.operations = results
                  if (this.model.id) {
                    if (this.tenantId == undefined) {
                      this.tenantId = this.model.businessUnit?.tenantId;
                    }
                    var sub2 = this.myFileApiService.getSecurityAuthContextWithTenant(this.model.id, this.tenantId!).subscribe(context => {
                      if (!context) {
                        context = new AuthContext();
                        context.ownerId = this.model.id;
                        context.id = this.model.id
                        context.loginType = LoginType.User;
                        context.authorizedOperations = new AuthorizedOperations;
                        context.authorizedOperations.operationAccess = OperationAccess.None
                        context.authorizedOperations.operations = []
                      }

                      this.newContext = context;
                      if (context.authorizedOperations?.operationAccess == 0) {
                        this.selectedAccessTypesArray = [{ name: "None", type: OperationAccess.None }]
                      } else if (context.authorizedOperations?.operationAccess == 1) {
                        this.selectedAccessTypesArray = [{ name: "Inherited", type: OperationAccess.Inherited }]
                      } else if (context.authorizedOperations?.operationAccess == 2) {
                        this.selectedAccessTypesArray = [{ name: "Custom", type: OperationAccess.Custom }]
                      } else if (context.authorizedOperations?.operationAccess == 3) {
                        this.selectedAccessTypesArray = [{ name: "Full", type: OperationAccess.Full }]
                      }

                      this.contextOperations = context.authorizedOperations?.operations;
                      this.selectedRolesArray = context.roles;
                      this.operations.forEach((element: OperationsModel, index: number) => {
                        this.operations[index] = this.recursiveElements(element, this.contextOperations);
                      })
                    })
                    this.unsubscribe.push(sub2)
                  }
                }
              });
              this.unsubscribe.push(sub);
            }

          } else {
            this.toasterNotificationService.showWarning($localize`:@@:Something went wrong. User could not be loaded.`, $localize`:@@:Error`);
          }
          this.disableEditing = false;
        });
      this.unsubscribe.push(sub);
    }

    this.myFileApiService.getSystemPublicSettings().subscribe((result: SettingsModel) => {
      if (result) {
        this.settingsModel = result;
        if (this.settingsModel.passwordComplexityOptions == undefined) {
          this.settingsModel.passwordComplexityOptions = new passwordComplexityOptions();
        }
      }
    });
   
  }

  ngOnDestroy() {
    this.operationsListService.clearListService();
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  override onSave(): void {
    this.submitted = true;
    if (this.validate()) {
      if (this.securityPermissionIsInRoleAdmin) {
        if (this.adminPasswordReset != undefined && this.adminPasswordReset.length > 0 && this.validateAdminPasswordReset()) {
          this.model.password = this.adminPasswordReset;
        }
      }
      this.modalEdited = false;
      if (this.newModel) {
        this.onCreate();
      } else {
        this.onUpdate();
      }
    }
  }

  validate() {
    this.submitted = true;
    if (
      this.model.name && this.model.name != "" &&
      this.model.lastName && this.model.lastName != "" &&
      this.model.email != undefined && this.model.email != '' && (this.model.email.match(this.emailPattern) != null)
    ) {
      return true;
    } else {
      this.activeTabId = 1;
    }
    this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
    return false;
  }

  onCreate(): void {
    this.disableEditing = true;
    this.model.userName = this.model.email
    this.model.fullName = this.model.name + " " + this.model.lastName;
    this.myFileApiService.createUser(this.model, this.tenantId).subscribe(returnedId => {
      if (returnedId) {
        this.toasterNotificationService.showSuccess($localize`:@@:The user has been created.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        this.model.id = returnedId;
      }
      this.disableEditing = false;
    })
  }

  onUpdate(): void {
    this.disableEditing = true;

    this.model.fullName = this.model.name + " " + this.model.lastName;

    this.myFileApiService.updateUser(this.model, this.tenantId).subscribe(result => {
      if (result === true) {
        if (this.display === 0) {
          this.toasterNotificationService.showSuccess($localize`:@@:Your profile has been updated.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        } else {
          this.toasterNotificationService.showSuccess($localize`:@@:The profile has been updated.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        }
      }
      this.disableEditing = false;
    })
  }

  openModalPermissions() {
    this.userPermissionModalService.openModal(this.model)
    var sub: Subscription = this.userPermissionModalService.modelChanged.subscribe((result: any) => {
      this.submitted = false;
      sub.unsubscribe();
    })
  }

  onUpdateCreditCard() {
    this.submitted = true;
    this.creditCardSubmit = true;

    if (this.creditCardPaymentInfoModel &&
      this.creditCardPaymentInfoModel.cardHolderName && this.creditCardPaymentInfoModel.cardHolderName != "" ||
      this.creditCardPaymentInfoModel.creditCardNumber && this.creditCardPaymentInfoModel.creditCardNumber != "" ||
      this.creditCardPaymentInfoModel.cvvNumber && this.creditCardPaymentInfoModel.cvvNumber != "" ||
      this.creditCardPaymentInfoModel.expiryDate && this.creditCardPaymentInfoModel.expiryDate != ""
    ) {
      if (
        this.creditCardPaymentInfoModel && this.creditCardPaymentInfoModel.billingAddress &&
        this.creditCardPaymentInfoModel.billingAddress.streetNumber && this.creditCardPaymentInfoModel.billingAddress.streetNumber != "" &&
        this.creditCardPaymentInfoModel.billingAddress.address1 && this.creditCardPaymentInfoModel.billingAddress.address1 != "" &&
        this.creditCardPaymentInfoModel.billingAddress.city && this.creditCardPaymentInfoModel.billingAddress.city != "" &&
        this.creditCardPaymentInfoModel.billingAddress.province && this.creditCardPaymentInfoModel.billingAddress.province != "" &&
        this.creditCardPaymentInfoModel.billingAddress.country && this.creditCardPaymentInfoModel.billingAddress.country != "" &&
        this.creditCardPaymentInfoModel.billingAddress.postalCode && this.creditCardPaymentInfoModel.billingAddress.postalCode != ""
      ) {

        this.creditCardPaymentInfoModel.creditCardNumberLast = this.creditCardPaymentInfoModel.creditCardNumber.slice(12, 16);
        this.creditCardPaymentInfoModel.expiryYear = parseInt(this.creditCardPaymentInfoModel.expiryDate.slice(3, 5));
        this.creditCardPaymentInfoModel.expiryMonth = parseInt(this.creditCardPaymentInfoModel.expiryDate.slice(0, 2));

        if (this.creditCardPaymentInfoModel.creditCardNumberLast && this.creditCardPaymentInfoModel.expiryYear && this.creditCardPaymentInfoModel.expiryMonth &&
          this.creditCardPaymentInfoModel.creditCardNumberLast != ""
        ) {
          this.disableEditing = true;
          this.myFileApiService.isCreditCardValid(this.creditCardPaymentInfoModel).subscribe(
            (result) => {
              this.disableEditing = false;
              if (result != undefined) {
                this.model.paymentInfo = this.creditCardPaymentInfoModel;
                this.nameOnCard = this.model.paymentInfo.cardHolderName;
                this.numberOnCard = `xxxx xxxx xxxx ${this.model.paymentInfo.creditCardNumber.substring(this.model.paymentInfo.creditCardNumber.length - 4)}`
                this.temptCreditCardReset();

                this.creditCardSubmit = false;
                this.onSave();
              } else {
                this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
              }
            }
          );
        } else {
          this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
        }
      } else {
        this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
      }
    } else {
      this.creditCardSubmit = false;
      this.onSave();
    }
  }

  temptCreditCardReset() {
    this.creditCardPaymentInfoModel = new CreditCardPaymentInfoModel();
    if (this.model && this.model.paymentInfo && this.model.paymentInfo.billingAddress) {
      this.creditCardPaymentInfoModel.billingAddress = this.model.paymentInfo.billingAddress;
    }
  }

  validateAdminPasswordReset(): boolean {
    var isValid = true;
    this.adminResetPasswordNonValid = undefined;

    if (this.adminPasswordReset != undefined && this.adminPasswordReset != '') {

      if (!(this.adminPasswordReset.length >= this.settingsModel.passwordComplexityOptions!.requiredLength)) {
        this.adminResetPasswordNonValid = `Password needs to contain at least ${this.settingsModel.passwordComplexityOptions!.requiredLength} characters. `;

        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireNonAlphanumeric && (this.adminPasswordReset.match(`(?=.*?[#?!@$%^&*-])`) == undefined)) {
        if (this.adminResetPasswordNonValid === undefined) {
          this.adminResetPasswordNonValid = '';
        }
        this.adminResetPasswordNonValid = `${this.adminResetPasswordNonValid}Password needs to contain at least one special (#?!@$%^&*-) character. `;

        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireLowercase && (this.adminPasswordReset.match(`(?=.*?[a-z])`) == undefined)) {
        if (this.adminResetPasswordNonValid === undefined) {
          this.adminResetPasswordNonValid = '';
        }
        this.adminResetPasswordNonValid = `${this.adminResetPasswordNonValid}Password needs to contain at least one lowercase (a-z) character. `;

        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireLowercase && (this.adminPasswordReset.match(`(?=.*?[A-Z])`) == undefined)) {
        if (this.adminResetPasswordNonValid === undefined) {
          this.adminResetPasswordNonValid = '';
        }
        this.adminResetPasswordNonValid = `${this.adminResetPasswordNonValid}Password needs to contain at least one uppercase (A-Z) character. `;

        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireDigit && (this.adminPasswordReset.match(`(?=.*?[0-9])`) == undefined)) {
        if (this.adminResetPasswordNonValid === undefined) {
          this.adminResetPasswordNonValid = '';
        }
        this.adminResetPasswordNonValid = `${this.adminResetPasswordNonValid}Password needs to contain at least one number (0-9) character. `;

        isValid = false;
      }
    }
    this.isAdminPasswordResetNonValid = !isValid;
    return isValid;
  }

  validatePassword(): boolean {
    this.passwordNonValid = undefined;
    this.confirmPasswordNonValid = undefined;
    this.oldPasswordNonValid = undefined;
    var isValid = true;

    if (this.newModel === false) {
      if (this.userOldPassword == undefined || this.userOldPassword == '') {
        this.oldPasswordNonValid = $localize`:@@:Old password is required`
        isValid = false;
      }
    }


    if (this.userNewPassword != undefined && this.userNewPassword != '') {
      if (!(this.userNewPassword.length >= this.settingsModel.passwordComplexityOptions!.requiredLength)) {
        this.passwordNonValid = `Password needs to contain at least ${this.settingsModel.passwordComplexityOptions!.requiredLength} characters. `;
        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireNonAlphanumeric && (this.userNewPassword.match(`(?=.*?[#?!@$%^&*-])`) == undefined)) {
        if (this.passwordNonValid === undefined) {
          this.passwordNonValid = '';
        }
        this.passwordNonValid = `${this.passwordNonValid}Password needs to contain at least one special (#?!@$%^&*-) character. `;
        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireLowercase && (this.userNewPassword.match(`(?=.*?[a-z])`) == undefined)) {
        if (this.passwordNonValid === undefined) {
          this.passwordNonValid = '';
        }
        this.passwordNonValid = `${this.passwordNonValid}Password needs to contain at least one lowercase (a-z) character. `;
        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireLowercase && (this.userNewPassword.match(`(?=.*?[A-Z])`) == undefined)) {
        if (this.passwordNonValid === undefined) {
          this.passwordNonValid = '';
        }
        this.passwordNonValid = `${this.passwordNonValid}Password needs to contain at least one uppercase (A-Z) character. `;
        isValid = false;
      }
      if (this.settingsModel.passwordComplexityOptions!.requireDigit && (this.userNewPassword.match(`(?=.*?[0-9])`) == undefined)) {
        if (this.passwordNonValid === undefined) {
          this.passwordNonValid = '';
        }
        this.passwordNonValid = `${this.passwordNonValid}Password needs to contain at least one number (0-9) character. `;
        isValid = false;
      }
    } else {
      this.passwordNonValid = $localize`:@@:New password is required`;
      isValid = false;
    }

    if (this.userConfirmPassword != undefined && this.userConfirmPassword != '') {
      if (!(this.userConfirmPassword !== undefined && this.userConfirmPassword !== '' && this.userConfirmPassword === this.userNewPassword)) {
        this.confirmPasswordNonValid = $localize`:@@Error_PasswordDNM:Password does not match`;
        isValid = false;
      }
    } else {
      this.confirmPasswordNonValid = $localize`:@@:Confirmation of password is required`;
      isValid = false;
    }

    return isValid;
  }

  onUpdatePassword() {
    this.submitted = true;
    this.passwordSubmit = true;

    if (this.validatePassword()) {
      this.model.password = this.userNewPassword;
      this.passwordSubmit = false;
      this.onSave();
    }

  }

  openSignaturePadModal(signatureOrInitial: boolean) {
    if (!this.model.signature) {
      this.model.signature = "";
    }
    if (!this.model.initials) {
      this.model.initials = "";
    }

    this.signatureService.openModal(signatureOrInitial);
    var sub: Subscription = this.signatureService.modelChanged.subscribe((result: any) => {
      if (result) {
        if (signatureOrInitial) {
          this.model.signature = result.signature;
        } else {
          this.model.initials = result.signature;
        }
      }
      sub.unsubscribe();
    })
  }

  signaturePNGTransform() {
    if (this.model.signature != "" && this.model.signature != undefined) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.model.signature}`);
    }
    return GlobalComponent.defaultNoSignatureImage;
  }

  initialsPNGTransform() {
    if (this.model.initials != "" && this.model.initials != undefined) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.model.initials}`);
    }
    return GlobalComponent.defaultNoSignatureImage;
  }

  stringLengthValidation(date: string | undefined): number {
    if (date == undefined) {
      return 0;
    } else {
      if (date.length == 8) {
        if (!date.includes('/')) {
          date = date.substring(0, 2) + "/" + date.substring(2, 4) + "/" + date.substring(4, 8)
        }
      }
      return date.length
    }
  }

  setCreditCardAddressToUsersAddress() {
    this.creditCardPaymentInfoModel.billingAddress = { ...this.creditCardPaymentInfoModel.billingAddress, ...this.model.address }
  }

  recursiveElements(element: OperationsModel, context: any, uncheckAll?: boolean, checkAll?: boolean): OperationsModel {
    if (checkAll == true) {
      element.isChecked = true;
      if (element.children && element.children.length > 1) {
        element.children.forEach((childElem: OperationsModel) => {
          childElem = this.recursiveElements(childElem, context, uncheckAll, checkAll)
        });
      }
    }
    if (uncheckAll == true) {
      element.isChecked = false;
      if (element.children && element.children.length > 1) {
        element.children.forEach((childElem: OperationsModel) => {
          childElem = this.recursiveElements(childElem, context, uncheckAll)
        });
      }
    } else {
      if (element.name) {
        if (context.includes(element.name)) {
          element.isChecked = true;
        }
      }
      if (element.children && element.children.length > 1) {
        var hasChildChecked: boolean = false;
        element.children.forEach((childElem: OperationsModel) => {
          childElem = this.recursiveElements(childElem, context);
          if (childElem.isChecked == true) {
            hasChildChecked = true;
          }
        });
        if (hasChildChecked) {
          element.isChecked = true;
        }
      }
    }
    return element;
  }

  hasChild = (_: number, node: OperationsModel) => !!node.children && node.children.length > 0;

  selectRole(rolesList: string[]) {
    if (rolesList.length == 0 || (rolesList.length < this.oldArrayList.length)) {
      this.operations.forEach((element: OperationsModel, index: number) => {
        this.operations[index] = this.recursiveElements(element, "", true);
      })
      this.selectedAccessTypesArray = [{ name: "None", type: OperationAccess.None }];
    }
    rolesList.forEach(role => {
      if (role == Roles.admin) {
        this.operations.forEach((element: OperationsModel, index: number) => {
          this.operations[index] = this.recursiveElements(element, RoleValueAdmin);
        })
      } else if (role == Roles.csr) {
        this.operations.forEach((element: OperationsModel, index: number) => {
          this.operations[index] = this.recursiveElements(element, RoleValueCSR);
        })
      } else if (role == Roles.profile) {
        this.operations.forEach((element: OperationsModel, index: number) => {
          this.operations[index] = this.recursiveElements(element, RoleValueProfile);
        })
      } else if (role == Roles.sandbox) {
        this.operations.forEach((element: OperationsModel, index: number) => {
          this.operations[index] = this.recursiveElements(element, RoleValueSandbox);
        })
      } else if (role == Roles.witness) {
        this.operations.forEach((element: OperationsModel, index: number) => {
          this.operations[index] = this.recursiveElements(element, RoleValueWitness);
        })
      }
      this.selectedAccessTypesArray = [{ name: "Inherited", type: OperationAccess.Inherited }]
    })
    this.oldArrayList = rolesList;
  }

  roleListController() {
    this.isRolesListOpen = !this.isRolesListOpen
  }

  accessTypeListController() {
    this.isOperationAccessListOpen = !this.isOperationAccessListOpen
  }

  isChecked(element: OperationsModel, context: any): OperationsModel {
    if (element.name && element.isChecked) {
      this.outPutOperations.push(element.name)
    }
    if (element.children && element.children.length > 1) {
      element.children.forEach((childElem: OperationsModel) => {
        childElem = this.isChecked(childElem, context)
      });
    }
    return element;
  }

  enable2FA() {
    this.model.isMultiFactorAuthenticationEnabled = !this.model.isMultiFactorAuthenticationEnabled;
    this.onUpdate();
  }

  setAllChildrenToParentNode(node: OperationsModel) {
    node.children?.forEach((child: OperationsModel) => {
      child.isChecked = node.isChecked;
    })
  }

  submitSecurityUpdates() {
    this.outPutOperations = [];
    this.operations.forEach((element: OperationsModel, index: number) => {
      this.operations[index] = this.isChecked(element, this.operations);
    })
    if (this.newContext.authorizedOperations) {
      this.newContext.authorizedOperations.operationAccess = this.selectedAccessTypesArray[0].type;
      this.newContext.authorizedOperations.operations = this.outPutOperations;
    }
    this.newContext.roles = this.selectedRolesArray;
    var sub3 = this.myFileApiService.updateSecurityAuthContextWithTenant(this.newContext, this.tenantId!).subscribe((result) => {
      if (result) {
        this.toasterNotificationService.showSuccess($localize`:@@: User permissions updated.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
      }
      this.unsubscribe.push(sub3)
    })
  }
}